import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoginComponent } from "./login/login.component";
import { AppRoutingModule } from "./app.routing.module";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { QuestionnaireComponent } from "./questionnaire/questionnaire.component";
import { InitialQuestionnaireComponent } from "./questionnaire/initial-questionnaire/initial-questionnaire.component";
import { PreInitialScreenComponent } from "./questionnaire/pre-initial-screen/pre-initial-screen.component";
import { ProgressTrackerComponent } from "./shared/progress-tracker/progress-tracker.component";
import { InfoScreenComponent } from "./shared/info-screen/info-screen.component";
import { PostInitialScreenComponent } from "./questionnaire/post-initial-screen/post-initial-screen.component";
import { ComprehensiveQuestionnaireComponent } from "./questionnaire/comprehensive-questionnaire/comprehensive-questionnaire.component";
import { QuestionsComponent } from "./shared/questions/questions.component";
import { ContactUsModalComponent } from './shared/contact-modal/contact-modal.component';
import { PostComprehensiveScreenComponent } from "./questionnaire/post-comprehensive-screen/post-comprehensive-screen.component";
import {
  NgbDateParserFormatter,
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbModule,
  NgbPaginationModule,
} from "@ng-bootstrap/ng-bootstrap";
import { JsonPipe } from "@angular/common";
import { CustomDateParserFormatter } from "./formatter/custom-date-parser-formatter";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { MfaSetupComponent } from "./shared/mfa-setup/mfa-setup.component";
import { QRCodeModule } from 'angularx-qrcode';
import { JourneySectionComponent } from "./shared/journey-section/journey-section.component";
import { AppointmentModalComponent } from "./shared/appointment-modal/appointment-modal.component";
import { ConfirmModalComponent } from "./shared/confirm-modal/confirm-modal.component";
import { QuillModule } from 'ngx-quill';
import { NotesModalComponent } from "./shared/notes-modal/notes-modal.component";
import { UploadDocumentModalComponent } from "./shared/upload-document-modal/upload-document-modal.component";
import { PostInitialRegretScreenComponent } from "./questionnaire/post-initial-regret-screen/post-initial-regret-screen.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { RedirectComponent } from "./redirect/redirect.component";
import { SummaryCardsComponent } from "./shared/summary-cards/summary-cards.component";
import { HospitalAdminComponent } from "./dashboard/hospital-admin/hospital-admin.component";
import { TabsComponent } from "./shared/tabs/tabs.component";
import { UserOverviewComponent } from "./dashboard/hospital-admin/user-overview/user-overview.component";
import { AddUserModalComponent } from "./shared/add-user-modal/add-user-modal.component";
import { AssignedDonorsModalComponent } from "./shared/assigned-donors-modal/assigned-donors-modal.component";
import { UserProfileModalComponent } from "./shared/user-profile-modal/user-profile-modal.component";
import { QuestionnaireOverviewComponent } from "./dashboard/hospital-admin/questionnaire-overview/questionnaire-overview.component";
import { BillingOverviewComponent } from "./dashboard/hospital-admin/billing-overview/billing-overview.component";
import { SignupComponent } from "./signup/signup.component";
import { DonorTableComponent } from "./shared/donor-table/donor-table.component";
import { DonorComponent } from "./dashboard/shared-views/donor/donor.component";
import { NgxChartsModule } from "@swimlane/ngx-charts"
import { EpicLookupModalComponent } from "./shared/epic-lookup-modal/epic-lookup-modal.component";
import { EsignatureModalComponent } from './shared/esignature-modal/esignature-modal.component';
import { SafeUrlPipe } from './shared/safe-url.pipe';
import { SlidingScaleComponent } from './shared/sliding-scale/sliding-scale.component';
import { ProfileTableComponent } from './shared/profile-table/profile-table.component';
import { DonorOverviewComponent } from "./dashboard/shared-views/donor-overview/donor-overview.component";
import { ReportingComponent } from "./dashboard/shared-views/reporting/reporting.component";
import { DonorJourneyComponent } from "./donor-journey/donor-journey.component";
import { CoordinatorComponent } from "./dashboard/coordinator/coordinator.component";
import { MrbViewComponent } from "./dashboard/shared-views/mrb-view/mrb-view.component";
import { SynopsisComponent } from "./dashboard/shared-views/synopsis/synopsis.component";
import { ProviderJourneyComponent } from "./dashboard/shared-views/provider-journey/provider-journey.component";


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    QuestionnaireComponent,
    PreInitialScreenComponent,
    InitialQuestionnaireComponent,
    PostInitialScreenComponent,
    ComprehensiveQuestionnaireComponent,
    PostComprehensiveScreenComponent,
    InfoScreenComponent,
    ProgressTrackerComponent,
    QuestionsComponent,
    MfaSetupComponent,
    DonorJourneyComponent,
    JourneySectionComponent,
    ProviderJourneyComponent,
    AppointmentModalComponent,
    ConfirmModalComponent,
    NotesModalComponent,
    UploadDocumentModalComponent,
    MrbViewComponent,
    PostInitialRegretScreenComponent,
    NavbarComponent,
    CoordinatorComponent, 
    RedirectComponent,
    SummaryCardsComponent,
    HospitalAdminComponent,
    TabsComponent,
    UserOverviewComponent,
    DonorOverviewComponent,
    AddUserModalComponent,
    AssignedDonorsModalComponent,
    UserProfileModalComponent,
    QuestionnaireOverviewComponent,
    BillingOverviewComponent,
    SignupComponent,
    DonorTableComponent,
    SynopsisComponent,
    DonorComponent,
    ReportingComponent,
    ContactUsModalComponent,
    EpicLookupModalComponent,
    EsignatureModalComponent,
    SafeUrlPipe,
    SlidingScaleComponent,
    ProfileTableComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule, // Required for forms
    AppRoutingModule,
    NgbModule, // Import AppRoutingModule
    NgbDropdownModule,
    NgbDatepickerModule,
    NgbPaginationModule,
    JsonPipe,
    QRCodeModule,
    QuillModule.forRoot(),
    NgxChartsModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent], // Specify the root component
})
export class AppModule {}
